import {
  HttpExclude,
  RequestExpose,
  Resource,
  ResourceCollection,
} from 'simpli-web-sdk'
import moment from 'moment'
import {NoneResource} from '@/model/NoneResource'
import {NotasInseridas} from '@/model/resource/NotasInseridas'
import {INotasInseridasResourcesHolder} from '@/interfaces/resource/INotasInseridasResourcesHolder'
import {NotasInseridasCollection} from '@/model/collection/NotasInseridasCollection'

@HttpExclude()
export class NotasInseridasFilterCollection extends NotasInseridasCollection {
  constructor() {
    super()
  }

  resource?: INotasInseridasResourcesHolder
  yearList: ResourceCollection<Resource> | null = null

  @RequestExpose() ano: number | string | null = null
  @RequestExpose() mes: number | string | null = null

  set mesAsResource(input: Resource | null) {
    this.mes = input?.$id || null
  }

  set anoAsResource(input: Resource | null) {
    this.ano = input?.$id || null
  }

  get mesAsResource() {
    return this.monthOptions().getResource(this.mes) || null
  }

  get anoAsResource() {
    return this.yearList?.getResource(this.ano) || null
  }

  monthOptions() {
    const months = moment.months().map(
      (month: string, index: number) =>
        ({
          $id: index + 1,
          $tag: month,
        } as Resource)
    )

    return new ResourceCollection(NoneResource, months)
  }

  async yearOptions() {
    const years = (await NotasInseridas.listAvailableYears()) as string[]

    const yearList = years.map(
      (year: string) =>
        ({
          $id: Number(year),
          $tag: year,
        } as Resource)
    )

    this.yearList = new ResourceCollection(NoneResource, yearList)
    return years
  }
}
